<!-- <div class="fp-webApp">  -->
<app-loader></app-loader>
<router-outlet></router-outlet>
<!-- </div> -->